import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from 'src/app/shared/services/user-services/user.service';
// import { UserService } from 'src/app/services/user-services/user.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-customer-conpany-profile',
  templateUrl: './customer-conpany-profile.component.html',
  styleUrls: ['./customer-conpany-profile.component.css'],
})
export class CustomerConpanyProfileComponent implements OnInit {
  pagination = {
    limit: 10,
    currentPage: 1,
    name:'',
    status:''
  };
  role: any = ['partner'];
  customerCompanyData: any = [];
  rolesList: any;
  // partnerData: any = [];
  totalPage: number = 0;
  totalRecords: any;
  searchItem: any = '';
  permissions: any = [];
  private subject: Subject<string> = new Subject();
  constructor(
    // private readonly userAuthService: UserService,
    // private readonly customerService: CustomerService
    private readonly userService: UserService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    // this.getRoles();
    this.setPermissions('partner-profile');
    this.getCustomerCompany(this.pagination);
    this.subject.pipe(
      debounceTime(1000)
    ).subscribe(searchTextValue => {
      this. getCustomerCompanyViaSearch(searchTextValue, this.pagination);
    });
  }
  changePage() {
    this.router.navigate(['/home/administration/portalBuilder']);
    console.log('navigate');
  }
  getRoles() {
    // let payload = {
    //   limit: 10000,
    //   currentPage: 1
    // }
    // this.roleService.getRoles(payload).subscribe((res) => {
    //   console.log(res)
    //   this.rolesList = res.data.data;
    //   let partnerRole = this.rolesList.find((item : any) => item.title == 'Partner')?._id;
    //   console.log(partnerRole)
    //   this.pagination.roleId = partnerRole;
    //   this.getCustomerCompany(this.pagination);
    // })
  }
  toggleView(id: any) {
    this.router.navigate(['home/customer/viewcustomerProfile', id]);
    // this.router.navigate(['home/profile/personal-details', id]);
  }
  setPermissions(type: string) {
    let allPermissions = JSON.parse(localStorage.getItem('permissions') as any);
    this.permissions = allPermissions.filter((item: any) => {
      return item.category == type
    })[0].permissions;

    console.log(this.permissions)
  }
  onKeyUp(event: any, pagination: any) {
    this.subject.next(event);
  }
  getCustomerCompany(pagination: any) {
    this.userService
      .getUsersWithPagination(pagination, this.searchItem, this.role)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.customerCompanyData = res.data.data;
          // this.partnerData = res.data.data;
          this.totalPage = res.data.totalPage;
          this.totalRecords = res.data.totalData;
        },
        error: (err) => console.error(err),
        complete: () => console.log('Observable complete'),
      });
  }
  getCustomerCompanyViaSearch(e: any,pagination:any) {
    const payload = pagination;
    this.pagination.currentPage=1
    this.searchItem = e.target.value ? e.target.value : '';
    console.log(this.searchItem);
    this.userService
      .getUsersWithSearch(payload, this.searchItem, this.role)
      .pipe(debounceTime(1000))
      .subscribe({
        next: (res) => {
          console.log(res);
          this.customerCompanyData = res.data.data;
          // this.partnerData = res.data.data;
          this.totalPage = res.data.totalPage;
          this.totalRecords = res.data.totalData;
        },
        error: (err) => console.error(err),
        complete: () => console.log('Observable complete'),
      });
  }

  nextPage() {
    // this.pagination.currentPage++;

    if (this.pagination.currentPage < this.totalPage) {
      this.pagination.currentPage++;
      this.getCustomerCompany(this.pagination);
    }
  }
  // nextPage() {
  //   if(this.pagination.currentPage < this.totalPage) {
  //     this.pagination.currentPage++;

  //     this.customerCompanyData(this.pagination);
  //   }
  // }

  // Method to handle previous page
  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getCustomerCompany(this.pagination);
    }
  }

  onLast() {
    this.pagination.currentPage = this.totalPage;
    this.getCustomerCompany(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getCustomerCompany(this.pagination);
  }

  onPageChange(page: any) {
    this.pagination.currentPage = page;
    this.getCustomerCompany(this.pagination);
  }

  routeToEditPortalBuilder(item: any) {
    this.router.navigate([
      `/home/customer/addEditPortalBuilder/${item._id}/${false}`,
    ]);
  }

  // onPageChange() {
  //   let payload = {
  //     "limit": 10,
  //     "currentPage": 1,
  //     "name": "raj"
  //   }
  //   this.userAuthService.getUsersWithPagination(payload).subscribe({
  //     next: res => console.log( res),
  //     error: err => console.error(err),
  //     complete: () => console.log('Observable complete')
  //   })
  // }

  // deleteCustomer() {
  //   this.customerService.deleteCustomer(1).subscribe({
  //     next: res => console.log( res),
  //     error: err => console.error(err),
  //     complete: () => console.log('Observable complete')
  //   })
  // }
}
